export const Categories = [
  "All",
  "Equity",
  "Fixed Income",
  "Hybrid",
  "Fund of Fund",
  "Index",
  // "ETF",
];
export const Type = [
  "All",
  "Growth",
  "Payout",
  "Reinvestment",
  "IDCW - Annual",
  "IDCW - Fortnightly",
  "IDCW - Halfyearly",
];
export const data = [
  {
    id: 1,
    name: "All",
  },
  {
    id: 2,
    name: "NFO",
  },
  {
    id: 3,
    name: "Equity",
  },
  {
    id: 4,
    name: "Debt",
  },
  {
    id: 5,
    name: "Hybrid",
  },
  {
    id: 6,
    name: "FOF",
  },
  {
    id: 7,
    name: "Index Funds",
  },
];
export enum OTP_INTERVAL {
  FIRST_TIME = 30,
  SECOND_TIME = 60,
}
// constants public exports
export {};

export enum INVESTMENT_TYPES {
  LUMPSUM = "Lumpsum",
  SIP = "SIP",
  DAILY_SIP = "Daily SIP",
}
export const INVESTMENT_MODES: Record<string, string> = {
  direct: "Direct",
  regular: "Regular",
};

export const INVESTMENT_ACCOUNT_TYPES: Record<string, string> = {
  individual: "Individual",
  // minor: "Minor", // Commented out - Minor account type is not currently available
  jointHolder: "Joint Holder",
};
export const INVESTMENT_DURATION_TYPES: Record<string, string> = {
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  quarterly: "Quarterly",
  halfyearly: "Halfyearly",
  yearly: "Yearly",
};
export const ACCOUNT_HOLDER_TYPES: Record<string, string> = {
  individual: "Individual",
  joint: "Minor",
};

export function removeInvescoIndia(str: string) {
  const regex = /^(Invesco India|Invesco)\s*-?\s*/i;
  return str?.replace(regex, "").trim();
}
export const TOAST_DURATION = 5500;

export const INCAPACITATION_TITLE =
  " I / We want the details of my / our nominee to be printed in the statement of holding, provided to me/ us by the AMC as follows; (please select, as appropriate)**";

export const INCAPACITATION_NOMINEE_INFO =
  "(I hereby authorize this nominee to operate my account on my behalf, in case of my incapacitation. He/She is authorized to encash my assets up to...)";

export const FUND_CODE = "120";

export enum INCAPACITATION {
  PERCENTAGE = "Percentage",
  AMOUNT = "Amount",
}

export enum NOMINEE_ID_TYPE {
  PAN = "PAN",
  AADHAAR = "Aadhaar",
  DRIVING_LICENCE = "Driving Licence",
  PASSPORT = "Passport",
}

export const nomineeIdTypes = [
  { label: "PAN", value: NOMINEE_ID_TYPE.PAN },
  { label: "Aadhaar", value: NOMINEE_ID_TYPE.AADHAAR },
  { label: "Driving Licence", value: NOMINEE_ID_TYPE.DRIVING_LICENCE },
  { label: "Passport Number", value: NOMINEE_ID_TYPE.PASSPORT },
];

export const MAX_NOMINEE_ALLOWED_INFO = "You can add upto 3 Nominees.";

export const NOMINEE_BENEFITS = [
  {
    icon: "TOOnFRO",
    label: "Ensures smooth transfer of investments in case of unforeseen events",
  },
  {
    icon: "Frame",
    label: "Easy and quick process to assign a nominee",
  },
  {
    icon: "Group",
    label: "You can update or change nominees anytime",
  },
  {
    icon: "Order",
    label: "Avoids legal complications for your family or legal heirs",
  },
  {
    icon: "HeartTick",
    label: "Gives you peace of mind knowing your assets are protected",
  },
];

export enum PAYMENT_MODE {
  NET_BANKING = "Net Banking",
  UPI = "UPI",
  ENACH = "eNACH",
  UPI_MANDATES = "UPI Mandates",
}

export enum FREQUENCY_VALUE {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
}

export enum SIP_TYPE_VALUE {
  NUMBER_OF_INSTALLMENTS = "No. of Installments",
  NUMBER_OF_YEARS = "No. of Years",
  UNTIL_CANCELLED = "Until Cancelled",
}

export enum AMOUNT_UNIT_VALUE {
  AMOUNT = "Amount",
  UNITS = "Units",
}
export const MINIMUM_ARN_CODE_LENGTH = 3;
export const MINIMUM_EUIN_CODE_LENGTH = 6;

export const OTHER_FUNDS: Record<any, string[]> = {
  Equity: [
    "Invesco India Business Cycle Fund",
    "Invesco India Contra Fund",
    "Invesco India ELSS Tax Saver Fund",
  ],
  "Fixed Income": ["Debt Fund 1", "Debt Fund 2"],
  "Fund of Funds": ["FoF 1", "FoF 2"],
  Exchange: ["ETF 1", "ETF 2"],
};

export const ACCOUNT_TYPE = {
  CURRENT: "Current",
  SAVINGS: "Saving",
  NRI: "NRI",
  NRO: "NRO",
};

export const CORPORATE_OUR_FUNDS_URL =
  "https://uat-newcorporate.invescomutualfund.com/our-funds?collections=";
